<template>
  <div class="VIPCubeBox">
    <div v-if="!user"  class="VIPCube">
      <button :style="{backgroundColor: bg?bg:'var(--color-pri)'}" @click="$emit('click')">填</button>
    </div>
    <div v-else class="VIPCube2">
      <div>
        <div class="iconuser"></div>
        <div class="info">
          <div>會員卡號: {{user.memberID}}</div>
          <div>會員名稱: {{user.name}}</div>
        </div>
        <div class="level"  v-if="user.level" :title="vipName[user.level]" :style="{backgroundImage: `url(${vipImg[user.level]})`}"></div>
      </div>
      <div :style="{position:'relative'}">
        <div><div>{{user.consume ? user.consume : 0}}</div></div>
        <hr>
        <div><div>{{user.balance ? user.balance : 0}}</div></div>
        <hoverInfoVue v-if="user.internalRemark"
          :style="{marginLeft: '5px', position: 'absolute', right: '8px', top: 0}" :direct="'right'" :info="user.internalRemark" :bg="'#FFE8E8'" color="#FF7373" :z="100">
          <div :class="user ? 'remarked' : ''"></div>
        </hoverInfoVue>
      </div>
    </div>
  </div>
</template>

<script>
import hoverInfoVue from '../../components/hoverInfo.vue'
import { mapState } from 'vuex'
export default {
  props: ['bg', 'user'],
  components: { hoverInfoVue },
  data () {
    return {
    }
  },
  computed: {
    ...mapState({
      vipName: 'vipName',
      vipImg: 'vipImg'
    })
  }
}
</script>

<style lang="scss" scoped>
.remarked {
  background-image: url(/svg/status/remarked.svg);
  background-size: 25px;
  width: 30px;
  height: 30px;
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  margin: auto;
  position: relative;
  z-index: 1;
}
.VIPCubeBox {
  width: 405px;
  height: 203px;
  background: #FFFFFF;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
  border-radius: 10px;
}
.VIPCube2 {
  width: 405px;
  height: 203px;
  overflow: hidden;
  border-radius: 10px;
  position: relative;
  &>div:nth-child(1) {
    background-color: var(--color-pri);
    height: 75px;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    padding-inline: 20px;
    gap: 14px;
    position: relative;
    .iconuser {
      width: 50px;
      height: 50px;
      border-radius: 25px;
      background-color: #FFFFFF;
      &::before {
        content: '';
        width: 50px;
        height: 50px;
        background-color: var(--color-pri);
        mask-image: url(/svg/icon/usercard.svg);
        display: inline-block;
        mask-repeat: no-repeat;
        mask-position: center;
      }
    }
    .info, .info>div {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      font-weight: 500;
      font-size: 18px;
      line-height: 26px;
      letter-spacing: 0.05em;
      color: #FFFFFF;
    }
    .level {
      position: absolute;
      border-radius: 15px;
      background-color: #FFFFFF;
      top: 10px;
      right: 10px;
      height: 30px;
      width: 30px;
      color: var(--color-pri);
      display: flex;
      align-items: center;
      font-size: 16px;
      background-size: 20px;
      background-repeat: no-repeat;
      background-position: center;
    }
  }
  &>div:nth-child(2) {
    margin: 18px 0px;
    display: grid;
    grid-template-columns: 1fr 1px 1fr;
    height: 86px;
    &>div{
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      &::before {
        width: fit-content;
        padding-inline: 10px;
        height: 29px;
        border-radius: 20px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        font-weight: 400;
        font-size: 16px;
      }
      &:nth-child(3)::before {
        content: '點數餘額';
        background: #FFB55F;
        color: #FFFFFF;
      }
      &:nth-child(1)::before {
        content: '總消費金額';
        background: #85B8B9;
        color: #FFFFFF;
      }
      &>div {
        display: flex;
        align-items: center;
        font-weight: 700;
        font-size: 40px;
        line-height: 40px;
        &::before {
          content: '';
          display: inline-block;
          width: 25px;
          height: 25px;
          margin-right: .5em;
        }
      }
      &:nth-child(3)>div{
        color: #FFB55F;
      }
      &:nth-child(1)>div{
        color: #85B8B9;
      }
      &:nth-child(3)>div::before {
          background-image: url(/svg/icon/points.svg);
      }
      &:nth-child(1)>div::before {
          background-image: url(/svg/icon/dollors.svg);
      }
    }
    hr {
      height: 100%;
      border: none;
      background-color: #6D6D6D;
      width: 1px;
    }
  }
}
.VIPCube {
  width: 405px;
  height: 203px;
  border-radius: 10px;
  background-image: url(/svg/icon/qrcode.svg);
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  &>button{
    position: absolute;
    width: 50px;
    height: 50px;
    border-radius: 10px;
    font-style: normal;
    font-weight: 400;
    font-size: 20px;
    text-align: center;
    letter-spacing: 0.1em;
    color: #FFFFFF;
    top: 10px;
    right: 12px;

  }
}
</style>
